import React, { useEffect, useState } from 'react';
import { ShoppingBag, Users, Package, DollarSign, TrendingUp, AlertTriangle, Layers } from 'lucide-react';
import api from '../../utils/api';
import './Admin.css';

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/stats').then(res => { setData(res.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const seedProducts = async () => {
    try {
      await api.post('/admin/seed');
      alert('Demo products seeded! Refresh the page.');
    } catch (err) {
      alert('Seeding failed: ' + err.message);
    }
  };

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}><div className="spinner" /></div>;

  const stats = data?.stats || {};

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1>Dashboard</h1>
        <button className="btn-primary" onClick={seedProducts}><Layers size={16} /> Seed Demo Products</button>
      </div>

      <div className="stats-grid">
        <StatCard icon={<ShoppingBag size={24} />} label="Total Orders" value={stats.totalOrders || 0} color="#1a4731" />
        <StatCard icon={<DollarSign size={24} />} label="Total Revenue" value={`CHF ${(stats.totalRevenue || 0).toFixed(2)}`} color="#c9a84c" />
        <StatCard icon={<Users size={24} />} label="Customers" value={stats.totalUsers || 0} color="#3b82f6" />
        <StatCard icon={<Package size={24} />} label="Products" value={stats.totalProducts || 0} color="#8b5cf6" />
        <StatCard icon={<TrendingUp size={24} />} label="Pending Orders" value={stats.pendingOrders || 0} color="#f59e0b" />
        <StatCard icon={<AlertTriangle size={24} />} label="Low Stock" value={stats.lowStockCount || 0} color="#ef4444" />
      </div>

      {data?.revenueByMonth?.length > 0 && (
        <div className="admin-card">
          <h3>Revenue by Month</h3>
          <div className="revenue-chart">
            {data.revenueByMonth.map((m, i) => {
              const max = Math.max(...data.revenueByMonth.map(x => x.revenue));
              const h = max > 0 ? (m.revenue / max) * 160 : 0;
              const months = ['','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
              return (
                <div key={i} className="bar-item">
                  <span className="bar-value">CHF {m.revenue.toFixed(0)}</span>
                  <div className="bar" style={{ height: h }} />
                  <span className="bar-label">{months[m._id.month]}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {data?.lowStockProducts?.length > 0 && (
        <div className="admin-card">
          <h3>Low Stock Alert</h3>
          <div className="low-stock-list">
            {data.lowStockProducts.map(p => (
              <div key={p._id} className="low-stock-item">
                <span>{p.name}</span>
                <span className="stock-badge">{p.stock} left</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function StatCard({ icon, label, value, color }) {
  return (
    <div className="stat-card">
      <div className="stat-icon" style={{ background: color + '22', color }}>{icon}</div>
      <div>
        <p className="stat-label">{label}</p>
        <p className="stat-value">{value}</p>
      </div>
    </div>
  );
}
